<template>
  <div class="receipt-container">
    <div v-if="isDataReady">
      <div
        v-for="(items, pageIndex) in hasil"
        :key="pageIndex"
        class="receipt-page"
      >
        <ReceiptHeader type="outlet" :data="outlet" />
        <div class="receipt-content">
          <h4 class="title">
            <b>Laporan Stok Barang</b>
          </h4>
          <div class="table-wrapper">
            <table class="detail-bon">
              <thead>
                <tr>
                  <th>No</th>
                  <th>Umur Barang</th>
                  <th>Tanggal</th>
                  <th>Kode Barang</th>
                  <th>Nama</th>
                  <th>Harga</th>
                  <th>Diskon</th>
                  <th>Mutasi Masuk</th>
                  <th>Mutasi Keluar</th>
                  <th>Total Sell</th>
                  <th>Stok</th>
                  <th>Stok Price</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(an_item, k) in items" :key="k">
                  <td>{{ pageIndex * 20 + k + 1 }}</td>
                  <td>{{ an_item.item_age }} Hari</td>
                  <td>{{ an_item.doc_date }}</td>
                  <td>{{ an_item.code }}</td>
                  <td>{{ an_item.name }}</td>
                  <td>{{ an_item.price | currency }}</td>
                  <td>{{ an_item.discount | currency }}</td>
                  <td>{{ an_item.mutation_inbound | number }}</td>
                  <td>{{ an_item.mutation_outbound | number }}</td>
                  <td>{{ an_item.total_sell | number }}</td>
                  <td>{{ an_item.stock | number }}</td>
                  <td>{{ an_item.stock_price | currency }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ReceiptHeader from '@/components/receipt/ReceiptHeader.vue'
import { appendStockParam } from '@/service/reportItemFilter'

export default {
  name: 'StockBarangPrint',
  components: {
    ReceiptHeader
  },
  data() {
    return {
      outlet: null,
      hasil: [],
      isDataReady: false
    }
  },
  mounted() {
    this.getOutlet()
    this.getReport()
  },
  methods: {
    async getOutlet() {
      try {
        const response = await this.$http.get(
          `${process.env.VUE_APP_API_URL}/outlets/${this.$route.query.outlet_id}`
        )
        if (response.status === 200) {
          this.outlet = response.data.data.outlets
        }
      } catch (error) {
        console.error('Error fetching outlet:', error)
      }
    },
    async getReport() {
      try {
        const params = new URLSearchParams({
          limit: this.$route.query.limit || 20,
          offset: 0,
          order_by: this.$route.query.order_by || '-item_age'
        })

        if (this.$route.query.code) {
          params.append('code', this.$route.query.code)
        }
        if (this.$route.query.name) {
          params.append('name', this.$route.query.name)
        }
        if (this.$route.query.show_all === 'true') {
          params.append('show_all', 'true')
        }
        appendStockParam(
          params,
          this.$route.query.stock_op,
          this.$route.query.stock_val
        )

        const response = await this.$http.get(
          `${
            process.env.VUE_APP_API_URL
          }/outlet-items/report-items?${params.toString()}`
        )
        if (response.status === 200) {
          this.hasil = this.splitLength(response.data.data.items, 20)
          this.isDataReady = true
          setTimeout(() => {
            window.print()
          }, 500)
        }
      } catch (error) {
        console.error('Error fetching report:', error)
      }
    },
    splitLength(array, length) {
      const result = []
      for (let i = 0; i < array.length; i += length) {
        result.push(array.slice(i, i + length))
      }
      return result
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/receipt.scss';
</style>
